<template>
  <div>
    <div class="row text-center" style="padding: 0 60px;" v-if="referrer === 'paystar'">
      <div  class="col-12 col-md-4 my-2"
            :style="hover_section == 'business' ? 'cursor: pointer;' : ''"
            @click="next_step('business')"
            @mouseenter="hover_section = 'business'"
            @mouseleave="hover_section = ''">
        <div class="my-4">
          <img src="/assets/new/svg/2.svg" width="111" height="111" :class="hover_section == 'business' ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="my-4">
          <button type="button" class="btn bg-white" :style="hover_section == 'business' ? 'color: #00c1a4 !important;' : ''">جهت استفاده در سایت یا اپلیکیشن</button>
        </div>
      </div>
      <div  class="col-12 col-md-4 my-2"
            :style="hover_section == 'personal' ? 'cursor: pointer;' : ''"
            @click="next_step('personal')"
            @mouseenter="hover_section = 'personal'"
            @mouseleave="hover_section = ''">
        <div class="my-4">
          <img src="/assets/new/svg/1.svg" width="111" height="111" :class="hover_section == 'personal' ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="my-4">
          <button type="button" class="btn bg-white" :style="hover_section == 'personal' ? 'color: #00c1a4 !important;' : ''">
              جهت استفاده در استارشاپ
              <span v-if="referrer == 'paystar'">پی استار</span>
          </button>
        </div>
      </div>
      <div  class="col-12 col-md-4 my-2"
            :style="hover_section == 'services' ? 'cursor: pointer;' : ''"
            @click="next_step('services')"
            @mouseenter="hover_section = 'services'"
            @mouseleave="hover_section = ''">
        <div class="my-4">
          <img src="/assets/new/svg/1.svg" width="111" height="111" :class="hover_section == 'services' ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="my-4">
          <button type="button" class="btn bg-white" :style="hover_section == 'services' ? 'color: #00c1a4 !important;' : ''">جهت استفاده در سرویس های لینک پرداخت</button>
        </div>
      </div>
    </div>
    <div class="row text-center" style="padding: 0 60px;" v-else-if="referrer === 'sepehr'">
      <div  class="col-12 col-md-4 my-2"
            :style="hover_section == 'business' ? 'cursor: pointer;' : ''"
            @click="next_step_sepehr('business')"
            @mouseenter="hover_section = 'business'"
            @mouseleave="hover_section = ''">
        <div class="my-4">
          <img src="/assets/new/svg/2.svg" width="111" height="111" :class="hover_section == 'business' ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="my-4">
          <button type="button" class="btn bg-white" :style="hover_section == 'business' ? 'color: #00c1a4 !important;' : ''">جهت استفاده در سایت یا اپلیکیشن</button>
        </div>
      </div>
      <div  class="col-12 col-md-4 my-2"
            :style="hover_section == 'personal' ? 'cursor: pointer;' : ''"
            @click="next_step_sepehr('personal')"
            @mouseenter="hover_section = 'personal'"
            @mouseleave="hover_section = ''">
        <div class="my-4">
          <img src="/assets/new/svg/1.svg" width="111" height="111" :class="hover_section == 'personal' ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="my-4">
          <button type="button" class="btn bg-white" :style="hover_section == 'personal' ? 'color: #00c1a4 !important;' : ''">
              جهت استفاده در سپهراستور
          </button>
        </div>
      </div>
      <div  class="col-12 col-md-4 my-2"
            :style="hover_section == 'services' ? 'cursor: pointer;' : ''"
            @click="next_step_sepehr('services')"
            @mouseenter="hover_section = 'services'"
            @mouseleave="hover_section = ''">
        <div class="my-4">
          <img src="/assets/new/svg/1.svg" width="111" height="111" :class="hover_section == 'services' ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="my-4">
          <button type="button" class="btn bg-white" :style="hover_section == 'services' ? 'color: #00c1a4 !important;' : ''">جهت استفاده در سرویس های لینک پرداخت</button>
        </div>
      </div>
    </div>
    <div class="row text-center" style="padding: 0 60px;" v-else>
      <div  class="col-12 col-md-4 my-2"
            :style="hover_section == 'business' ? 'cursor: pointer;' : ''"
            @click="next_step_pejen('business')"
            @mouseenter="hover_section = 'business'"
            @mouseleave="hover_section = ''">
        <div class="my-4">
          <img src="/assets/new/svg/2.svg" width="111" height="111" :class="hover_section == 'business' ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="my-4">
          <button type="button" class="btn bg-white" :style="hover_section == 'business' ? 'color: #00c1a4 !important;' : ''">جهت استفاده در سایت یا اپلیکیشن</button>
        </div>
      </div>
      <div  class="col-12 col-md-4 my-2"
            :style="hover_section == 'personal' ? 'cursor: pointer;' : ''"
            @click="next_step_pejen('personal')"
            @mouseenter="hover_section = 'personal'"
            @mouseleave="hover_section = ''">
        <div class="my-4">
          <img src="/assets/new/svg/1.svg" width="111" height="111" :class="hover_section == 'personal' ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="my-4">
          <button type="button" class="btn bg-white" :style="hover_section == 'personal' ? 'color: #00c1a4 !important;' : ''">جهت استفاده در فروشگاه شبکه های اجتماعی</button>
        </div>
      </div>
      <div  class="col-12 col-md-4 my-2"
            :style="hover_section == 'services' ? 'cursor: pointer;' : ''"
            @click="next_step_pejen('services')"
            @mouseenter="hover_section = 'services'"
            @mouseleave="hover_section = ''">
        <div class="my-4">
          <img src="/assets/new/svg/1.svg" width="111" height="111" :class="hover_section == 'services' ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="my-4">
          <button type="button" class="btn bg-white" :style="hover_section == 'services' ? 'color: #00c1a4 !important;' : ''">جهت استفاده از سرویس های لینک پرداخت و <br/>پرداخت شناسه‌دار</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { i18n } from "@/plugins/i18n";
import {mapGetters} from "vuex";
import { shopType } from "@/constants/ShopType";
import {PEGEN_ADDRESS, SHOP_ADDRESS, MAIN_ADDRESS, PEGEN_REFRENCE, SHOP_REFRENCE, SEPEHR_ADDRESS} from "@/common/config"

export default {
  props: {
    wizard: Object,
    form_data: Object,
  },
  data() {
    return {
      hover_section: '',
      shop_type: shopType,
      referrer: 'paystar',
        slug: '',
    }
  },
  computed: {
    ...mapGetters('user', [
      'current_user'
    ]),
  },
  methods: {
    next_step(val) {
      if (val == 'business') {
        this.form_data.site_address = 'https://';
        this.form_data.type = this.shop_type.SERVICES;
        document.getElementById('site_address').disabled = false
      } else if (val == 'personal') {
        this.form_data.site_address = SHOP_ADDRESS + this.slug;
        this.form_data.type = this.shop_type.SERVICES;
        document.getElementById('site_address').disabled = true
        if (this.slug == null) {
            document.getElementById('site_address').disabled = false
            this.form_data.site_address = SHOP_ADDRESS;
        }
      }else if(val === 'services'){
        this.form_data.site_address = MAIN_ADDRESS + this.current_user.username;
        this.form_data.type = this.shop_type.PARDAKHT_SHAKHSI;
        document.getElementById('site_address').disabled = true
      } 
      else {
        return;
      }

      this.wizard.current_step = 2;
    },
    next_step_pejen(val) {
      if (val == 'business') {
        this.form_data.site_address = 'https://';
        this.form_data.type = this.shop_type.SERVICES;
        document.getElementById('site_address').disabled = false
      } else if (val == 'personal') {
          this.form_data.site_address = PEGEN_ADDRESS + this.slug;
        this.form_data.type = this.shop_type.SERVICES;
          document.getElementById('site_address').disabled = true
          if (this.slug == null) {
              document.getElementById('site_address').disabled = false
              this.form_data.site_address = PEGEN_ADDRESS;
          }
      }else if(val === 'services'){
        this.form_data.site_address = PEGEN_ADDRESS + this.current_user.username;
        this.form_data.type = this.shop_type.PARDAKHT_SHAKHSI;
        document.getElementById('site_address').disabled = true
      } 
      else {
        return;
      }

      this.wizard.current_step = 2;
    },
    next_step_sepehr(val) {
      if (val == 'business') {
        this.form_data.site_address = 'https://';
        this.form_data.type = this.shop_type.SERVICES;
        document.getElementById('site_address').disabled = false
      } else if (val == 'personal') {
          this.form_data.site_address = SEPEHR_ADDRESS + this.slug;
        this.form_data.type = this.shop_type.SERVICES;
          document.getElementById('site_address').disabled = true
          if (this.slug == null) {
              document.getElementById('site_address').disabled = false
              this.form_data.site_address = SEPEHR_ADDRESS;
          }
      }else if(val === 'services'){
        this.form_data.site_address = SEPEHR_ADDRESS + this.current_user.username;
        this.form_data.type = this.shop_type.PARDAKHT_SHAKHSI;
        document.getElementById('site_address').disabled = true
      }
      else {
        return;
      }

      this.wizard.current_step = 2;
    },
  },
  mounted(){
      let shop = localStorage.getItem('shop_name')
      let slug = localStorage.getItem('shop_slug')

      if (slug !== undefined)
          this.slug = slug


      if (shop === 'pegen.ir'){
          this.next_step_pejen('personal')
          this.referrer = 'pegen';
      } else if(shop === 'paystar.shop') {
          this.referrer = 'paystar';
          this.next_step('personal')
      } else if(shop === 'sepehr.store') {
          this.referrer = 'sepehr';
          this.next_step_sepehr('personal')
      } else
          this.next_step('business');
  }
};
</script>

<style scoped>
.filter_green {
  filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg) brightness(91%) contrast(101%);
}

.filter_gray {
  filter: invert(87%) sepia(1%) saturate(200%) hue-rotate(314deg) brightness(101%) contrast(86%);
}
</style>